import { render, staticRenderFns } from "./product-suppliers.vue?vue&type=template&id=204c1452&scoped=true"
import script from "./product-suppliers.vue?vue&type=script&lang=js"
export * from "./product-suppliers.vue?vue&type=script&lang=js"
import style0 from "./product-suppliers.vue?vue&type=style&index=0&id=204c1452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204c1452",
  null
  
)

export default component.exports